<template>
  <div id="instructorSessions" class="mt-2 overflow-y-auto" style="height: auto; max-height:90vh;">
    <div
      v-for="(month, index) in sessionsAgenda.sessions"
      :id="month.key"
      ref="monthsRef"
      :key="`month_${index}`"
    >
      <div>
        <div class="d-flex flex-wrap relative">
          <div class="titleBorder absolute" style="width: 100%; height:1px; top: 19px;"></div>
          <div class="mx-auto d-inline-block center px-3 white-bg z1">
            <h2>{{ month.label }}</h2>
          </div>
        </div>
      </div>
      <div
        v-for="(week, weekIndex) in month.weeks"
        :key="`week_${weekIndex}`"
      >
        <v-row v-if="!week.doesDaysHaveSessions" no-gutters>
          <v-col cols="3" />
          <v-col cols="9">
            <div class="weekLabel">
              {{ week.weekLabel }}
            </div>
          </v-col>
        </v-row>
        <div v-else>
          <v-row no-gutters>
            <v-col cols="3" />
            <v-col cols="9">
              <div class="weekLabel">
                {{ week.weekLabel }}
              </div>
            </v-col>
          </v-row>
          <template v-for="(day, dayIndex) in week.days">
            <div
              v-if="day.dayHaveSession"
              :key="`day_${dayIndex}`"
              class="d-flex"
            >
              <v-col :id="day.day_label" cols="3" class="d-inline-block full-height pa-0">
                <v-row no-gutters class="mt-2">
                  <v-col cols="12" class="d-flex justify-center">
                    {{ day.week_day }}
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center">
                    {{ day.day }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="9" class="d-inline-block pa-0 pt-2">
                <div
                  v-for="(session, sessionIndex) in day.sessions"
                  v-if="day.dayHaveSession"
                  :key="`session_day_${sessionIndex}`"
                  :class="sessionIndex === day.sessions.length -1 ? 'pb-3' : 'pb-1'"
                >
                  <div class="sessionDiv mr-3 py-2" @click="openSessionDetail(session)">
                    <p class="ma-0 pl-3">{{ session.name }}</p>
                    <p class="ma-0 pl-3">{{ session.timeLabel }}</p>
                  </div>
                </div>
              </v-col>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onUpdated, onMounted, ref, inject } from '@vue/composition-api';
import { format } from 'date-fns';
import { fr } from 'date-fns/esm/locale';
import store from '@/store';
import router from '@/router';

export default {
  setup () {
    const monthsRef = ref([]);
    const currentMonth = inject('currentMonth');
    const currentPickerDate = inject('currentPickerDate');

    const sessionsAgenda = computed(() => store.getters.instructorSessions);

    const openSessionDetail = session => {
      store.commit('setSelectedSession', session);
      router.push({
        name: 'SessionDetail',
        params: { session_id: session.id }
      });
    };

    onUpdated(() => {
      document.getElementById('instructorSessions').addEventListener('scroll', () => {
        const element = document.getElementById('instructorSessions');
        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
          // load more session if needed
        }
      });
    });

    onMounted(() => {
      const options = { threshold: 0 };
      const visibles = [];
      const observer = new IntersectionObserver((entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            visibles.push(entry.target.id);
          } else {
            const index = visibles.findIndex(v => v === entry.target.id);
            if (index !== -1) {
              visibles.splice(index, 1);
            }
          }
          const sorted = visibles.sort((a, b) => (a < b ? -1 : 1));
          if (sorted.length) {
            const date = sorted[0].split('month_')[1];
            const label = format(new Date(date), 'LLLL', { locale: fr });
            if (router.app.$route.name === 'Home') {
              currentMonth.value = label;
              currentPickerDate.value = date;
            }
          }
        });
      }), options);

      monthsRef.value.map(section => {
        observer.observe(section);
      });
    });

    return { sessionsAgenda, openSessionDetail, monthsRef, currentMonth };
  }
};
</script>

<style scoped>
  .sessionDiv {
    border: 1px solid white;
    background-color: lightblue;
    border-radius: 10px;
  }
  .sessionDiv:not(:first-child) {
    margin-top: 0.2rem;
  }

  .weekLabel {
    font-size: 13px;
    color: darkgray;
  }

  .titleBorder {
    border-bottom: red solid 1px ;
  }
</style>
